module.exports = __webpack_public_path__ + "static/img/解决方案-化工行业智能监管解决方案-火灾烟雾毫秒预警.1a621d83.png";